// extracted by mini-css-extract-plugin
export var intro = "intro-module--intro--1RQvO";
export var video = "intro-module--video--gkwK8";
export var introImage = "intro-module--introImage--3sJfS";